export const ADMIN_EVENT_LIST_PATH = '/admin/events';
export const ADMIN_EVENT_ADD_PATH = '/admin/events/add';
export const ADMIN_EVENT_DETAIL_PATH = '/admin/events/:eventId';
export const ADMIN_EVENT_GENERAL_PATH = '/admin/events/:eventId/general';
export const ADMIN_EVENT_ADVANCED_PATH = '/admin/events/:eventId/advanced';
export const ADMIN_EVENT_SESSIONS_PATH = '/admin/events/:eventId/sessions';
export const ADMIN_EVENT_SESSIONS_ADD_PATH = '/admin/events/:eventId/sessions/add';
export const ADMIN_EVENT_SESSIONS_EDIT_PATH = '/admin/events/:eventId/sessions/:sessionId/edit';
export const ADMIN_EVENT_ORGANIZATIONS_PATH = '/admin/events/:eventId/organizations';
export const ADMIN_EVENT_ATTENDEES_PATH = '/admin/events/:eventId/attendees';
export const ADMIN_EVENT_PAGES_PATH = '/admin/events/:eventId/pages';
export const ADMIN_EVENT_PAGES_ADD_PATH = '/admin/events/:eventId/pages/add';
export const ADMIN_EVENT_PAGES_EDIT_PATH = '/admin/events/:eventId/pages/:pageId/edit';
export const ADMIN_EVENT_ANALYTICS_PATH = '/admin/events/:eventId/analytics/:chartGrid?';
export const ADMIN_SCHEDULED_EMAILS_PATH = '/admin/events/:eventId/emails';
export const ADMIN_SCHEDULED_EMAILS_ADD_PATH = '/admin/events/:eventId/emails/add';
export const ADMIN_SCHEDULED_EMAILS_DETAIL_PATH = '/admin/events/:eventId/emails/:emailId';
